import { __makeTemplateObject } from "tslib";
import styled from "styled-components";
export var DevelopedByTakeatContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  flex-direction: ", ";\n  width: ", ";\n  height: ", ";\n\n  span {\n    font-size: ", "px;\n    white-space: nowrap;\n    color: ", ";\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  flex-direction: ", ";\n  width: ", ";\n  height: ", ";\n\n  span {\n    font-size: ", "px;\n    white-space: nowrap;\n    color: ", ";\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n  }\n"])), function (_a) {
    var horizontal = _a.horizontal;
    return (horizontal ? "row" : "column");
}, function (_a) {
    var width = _a.width, horizontal = _a.horizontal;
    return horizontal || !width ? "auto" : "".concat(width, "px");
}, function (_a) {
    var height = _a.height, horizontal = _a.horizontal;
    return !horizontal || !height ? "auto" : "".concat(height, "px");
}, function (_a) {
    var width = _a.width, height = _a.height;
    return width ? (width * 12) / 105 : height ? (height * 12) / 25 : 12;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral.default;
});
var templateObject_1;
//# sourceMappingURL=styles.js.map